import * as Yup from 'yup'
import { Translate } from 'next-translate'
import { URL_REGEX } from 'shared/enums/regex'
import {
  isPossiblePhoneNumber,
  Value as InputTelephoneValue
} from 'react-phone-number-input'

/**
 * Helper for custom Yup validations.
 */

/**
 * Validate URL
 *
 * @example
 * const ValidationSchema = Yup.object().shape({ url: yupValidateUrl(t) })
 */
export const yupValidateUrl = (t: Translate) =>
  Yup.string().matches(URL_REGEX, t('common:url-not-recognised'))

/**
 * Validate telephone inputs.
 *
 * @example
 * const ValidationSchema = Yup.object().shape({ telephone: yupValidateTelephone(t) })
 */
export const yupValidateTelephone = (t: Translate) =>
  Yup.string().test({
    name: 'invalid-phone-number',
    message: t('common:invalid-phone-number'),
    test: value => {
      if (!value) return true // Don't validate if it is undefined
      return isPossiblePhoneNumber(value as InputTelephoneValue)
    }
  })

/**
 * Simple validation for email inputs.
 *
 * @example
 * const ValidationSchema = Yup.object().shape({ email: yupValidateEmail(t) })
 */
export const yupValidateEmail = (t: Translate) =>
  Yup.string()
    .email(t('common:enter-valid-email'))
    .typeError(t('common:enter-valid-email'))
